import { Colors } from './colors';
import { Typographies } from './typographies';

import './base-styles.config';

const BaseStyles = () => {
  return (
    <div>
      <Colors />
      <Typographies />
    </div>
  );
};

export default BaseStyles;
